import {
  SET_DADOS_COMPLEMENTARES_ESTADO_CIVIL,
  LOADING_DADOS_COMPLEMENTARES_ESTADO_CIVIL,
  ERROR_DADOS_COMPLEMENTARES_ESTADO_CIVIL,

  SET_DADOS_COMPLEMENTARES_GENERO,
  LOADING_DADOS_COMPLEMENTARES_GENERO,
  ERROR_DADOS_COMPLEMENTARES_GENERO,

  SET_DADOS_COMPLEMENTARES_PAIS,
  LOADING_DADOS_COMPLEMENTARES_PAIS,
  ERROR_DADOS_COMPLEMENTARES_PAIS,

  CHANGE_DADOS_COMPLEMENTARES_VALUE_FORM,
  HANDLE_CHANGE_DADOS_GENERO,
  HANDLE_CHANGE_DADOS_ESTADO_CIVIL,
  HANDLE_CHANGE_DADOS_FLAG_DOMICIO_FISCAL,
  HANDLE_CHANGE_DADOS_FLAG_PESSOA_AMERICANA,
  HANDLE_CHANGE_TYPEAHEAD
} from './types';

const initialState = {
  loadingDadosComplementaresEstadoCivil: false,
  loadingDadosComplementaresGenero: false,
  loadingDadosComplementaresPais: false,

  errorListDadosComplementaresEstadoCivil: null,
  errorListDadosComplementaresGenero: null,
  errorListDadosComplementaresPais: null,

  formDados: {
    dadosComplementares_nomeConjuge: '',
    dadosComplementares_cpfConjuge: '',
    dadosComplementares_dataNascimentoConjuge: '',
    dadosComplementares_nomeMae: '',
    dadosComplementares_nomePai: '',
    dadosComplementares_SocialSecurityNumber: ''
  },

  dadosComplementares_pessoaAmericana: false,
  dadosComplementares_domicilioFiscal: '',
  dadosComplementares_genero: 0,
  dadosComplementares_estadoCivil: "",
  dadosComplementares_PaisNascimento: null,
  typeaHeadDadosPaisDomicilioValue: "",
  dadosComplementares_paisFiscal:'BRA',

  typeaHeadDadosPaisList: [],

  dropdownDadosGeneroList: [],
  dropdownDadosEstadoCivilList: []
}


export default function dadosComplementaresReducer(state = initialState, action) {
  switch (action.type) {

    case SET_DADOS_COMPLEMENTARES_ESTADO_CIVIL:
      return { ...state, dropdownDadosEstadoCivilList: action.payload }
    case LOADING_DADOS_COMPLEMENTARES_ESTADO_CIVIL:
      return { ...state, loadingDadosComplementaresEstadoCivil: action.payload }
    case ERROR_DADOS_COMPLEMENTARES_ESTADO_CIVIL:
      return { ...state, errorListDadosComplementaresEstadoCivil: action.payload }

    case SET_DADOS_COMPLEMENTARES_GENERO:
      return { ...state, dropdownDadosGeneroList: action.payload }
    case LOADING_DADOS_COMPLEMENTARES_GENERO:
      return { ...state, loadingDadosComplementaresGenero: action.payload }
    case ERROR_DADOS_COMPLEMENTARES_GENERO:
      return { ...state, errorListDadosComplementaresGenero: action.payload }

    case SET_DADOS_COMPLEMENTARES_PAIS:
      return { ...state, typeaHeadDadosPaisList: action.payload }
    case LOADING_DADOS_COMPLEMENTARES_PAIS:
      return { ...state, loadingDadosComplementaresPais: action.payload }
    case ERROR_DADOS_COMPLEMENTARES_PAIS:
      return { ...state, errorListDadosComplementaresPais: action.payload }

    case CHANGE_DADOS_COMPLEMENTARES_VALUE_FORM:
      return { ...state, formDados: action.payload }

    case HANDLE_CHANGE_DADOS_GENERO:
      return { ...state, dadosComplementares_genero: action.payload }

    case HANDLE_CHANGE_DADOS_ESTADO_CIVIL:
      return { ...state, dadosComplementares_estadoCivil: action.payload }

    case HANDLE_CHANGE_DADOS_FLAG_DOMICIO_FISCAL:
      return { ...state, dadosComplementares_domicilioFiscal: action.payload }

      case HANDLE_CHANGE_DADOS_FLAG_PESSOA_AMERICANA:
        return { ...state, dadosComplementares_pessoaAmericana: action.payload }

    case HANDLE_CHANGE_TYPEAHEAD:
      let {name, value} = action.payload;
      let newState = {...state};
      newState[name] = value;  
    
      return newState;

    default:
      return state
  }
}
